import { telehealthCaseUrl } from "@pages/AdminDashboard/telehealthLinks";
import { ExternalLink, shortenIdentifier } from "@pages/AdminDashboard/ui/DataTable/cells";

interface CaseReferenceProps {
  caseNumber?: number;
  caseId?: string | null;
}

// The Case ID by its first segment, linked to the Case in the telehealth vendor (SHIPUI-R32); a
// Case with no Case ID is named by its number with a "#" and links nowhere (SHIPUI-R37).
export const CaseReference = ({ caseNumber, caseId }: CaseReferenceProps) => {
  if (!caseId) return <>Case #{caseNumber}</>;

  return (
    <>
      Case{" "}
      <ExternalLink href={telehealthCaseUrl(caseId)} title={caseId}>
        {shortenIdentifier(caseId)}
      </ExternalLink>
    </>
  );
};
